import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, shadowUp } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const noSearchResultsWrapper = css`
  text-align: center;
  padding-top: ${spacing.xxxxl}px;
  margin: 0 0 ${spacing.xl}px 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${shadowUp};
    `,
  )};
`;

export const heading = css``;

export const headingText = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${theme.responsiveText.BODY.MD}
  color: var(--neutral-black-70);
  display: block;
`;

export const headingTerm = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${theme.responsiveText.HEADING.LG};
  display: block;
`;

export const info = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${theme.responsiveText.BODY.MD};
  margin-top: ${spacing.xxxl}px;
`;
